var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.729,
    height: 9.704,
    viewBox: "0 0 5.729 9.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M12.069,6.03,8.062,10.02a.864.864,0,0,0,0,1.222l4.007,3.989a.862.862,0,0,0,1.216-1.221L9.892,10.631l3.393-3.378A.862.862,0,0,0,12.069,6.03Z",
    transform: "translate(-7.809 -5.779)",
    fill: "#1b2737",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLeftArrow);
export default __webpack_public_path__ + "static/media/BlueLeftArrow.136d1e283946529e8ed081868a2aa9c7.svg";
export { ForwardRef as ReactComponent };